import { makeStyles } from "@mui/styles";
const useStyle = makeStyles((theme ) => ({
    menuCard: {
        "&.MuiCard-root": {
          // minWidth:105
          marginInline: "10px",
          marginBlock: "10px",
          marginBlockStart: "30px",
          boxShadow: " 0px 1px 5px 0px rgba(194,194,194,1)",
          borderRadius: "3px",
          "& .MuiCardHeader-root": {
            padding: "8px 16px",
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.common.white,
          },
          "& .MuiCardContent-root": {
            padding: "0px 16px",
          },
        },
      },
}))
export default useStyle;